import { PasswordPolicyError } from "@/config/types";

export function getPasswordInfo(
  passwordRequirements: Record<PasswordPolicyError, boolean>,
  newPassword: string,
  confirmNewPassword: string,
) {
  const passwordsDontMatch = newPassword !== confirmNewPassword;
  const passwordIsEmpty = newPassword.length === 0;
  const passwordInvalid =
    passwordRequirements.missing_digit ||
    passwordRequirements.missing_uppercase_letter ||
    passwordRequirements.missing_symbol ||
    passwordRequirements.missing_lowercase_letter ||
    passwordRequirements.too_short;

  return { passwordsDontMatch, passwordIsEmpty, passwordInvalid };
}
